import { render, staticRenderFns } from "./Objections.vue?vue&type=template&id=194d3e9d&scoped=true"
import script from "./Objections.vue?vue&type=script&lang=ts"
export * from "./Objections.vue?vue&type=script&lang=ts"
import style0 from "./Objections.vue?vue&type=style&index=0&id=194d3e9d&prod&lang=scss&scoped=true"
import style1 from "./Objections.vue?vue&type=style&index=1&id=194d3e9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194d3e9d",
  null
  
)

export default component.exports